import React, { useEffect, useState } from 'react';


const Argitech3 = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  
  return (
   <div className='bg-white '>
     <div className='px-4 md:px-40 pt-3'>
     <h1 className="text-[14px] md:text-[36px] font-bold mt-3 text-[#FDBD26]">AgriTech</h1>
      <h1 className="text-[12px] md:text-[32px] font-bold mb-4 text-black">Revolutionizing Agriculture with Digital solutions</h1>

      <div className="relative w-full  overflow-hidden  rounded-lg bg-white">
        <div className="relative w-full rounded-lg">
          {isLoading && (
            <div className="absolute inset-0 flex items-center justify-center bg-gray-100 z-10">
              <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-[#742B3E] border-solid"></div>
            </div>
          )}
          <img
              src="https://res.cloudinary.com/dzngpgki4/image/upload/v1743776596/image_1502_utmsek.png"
              alt="Play"
              className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[40px] h-[40px] md:w-[133px] md:h-[133px] z-10"
            />
          <img
            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744553588/image-2_b1tpiy.png"
            alt="Securing Agriculture in Namibia"
            className={`w-full md:h-[622px] object-cover   rounded-lg transition-opacity duration-500 ${isLoading ? 'opacity-0' : 'opacity-100'}`}
            onLoad={() => setIsLoading(false)}
          />
             {!isLoading && (
            <div className="absolute md:bottom-2 bottom-6 md:left-0 w-full px-4">
            <h2 className="text-white   md:text-[24px] font-bold mb-2">FOOD SECURITY</h2>
                <h2 className="text-white text-[14px] md:text-[40px] font-bold -mt-3" style={{ lineHeight: '1.20' }}>
                  Innovation for Sustainable <br /> Future
                </h2>
            </div>
          )}
        </div>
      </div>

      <div className="px-1">
  {/* Content Section */}
  <div className="mt-5 max-w-screen-xl w-full">
    <h3 className="text-black font-normal text-[14px] md:text-[30px]">
      April 13, 2025
    </h3>
    <div className="flex items-center gap-6 md:gap-8 text-[24px] font-normal text-black">
      <p>Story by Editorial team</p>
      <div className="flex items-center gap-2 text-[#155528]">
        <img
          src="https://res.cloudinary.com/dzngpgki4/image/upload/v1743893169/Time_progress_light_ecbt3q.png"
          alt="Clock"
          className="h-6 w-6 md:h-8 md:w-8"
        />
        <p>2 Minutes read</p>
      </div>
    </div>
  </div>

  <h3 className="text-black font-bold text-[10px] md:text-[32px] mt-3 md:mt-5">
    Transforming Namibia's Agriculture: Embracing Innovation for a Sustainable Future
  </h3>

  {/* Main Text Section */}
  <div className="md:mt-5 mt-2 md:space-y-10 space-y-5">
    <p className="md:text-[32px] text-[8px] text-black font-normal">
      Namibia's agricultural sector stands as a cornerstone of its economy and society, directly or indirectly supporting the majority of its population. The sector contributes just over four percent to the nation's GDP. There is still potential for improving agricultural productivity and enhancing its impact on sustainable development.
      <br />
      Currently, the sector is predominantly characterized by subsistence farming, with a heavy reliance on rainfall. This dependency renders the sector vulnerable to climatic variations, particularly droughts, which are becoming more frequent due to climate change. Limited access to modern farming technologies, inadequate infrastructure, and restricted market access further exacerbate the challenges faced by Namibian farmers.
      <br /><br />
      <strong>The Strategy for the Transformation of the Agriculture Sector (STAS)</strong>
      <br />
      In response to these challenges, the Namibian government introduced the Strategy for the Transformation of the Agriculture Sector (STAS). Developed by the Ministry of Agriculture, Water and Land Reform, STAS serves as a comprehensive roadmap aimed at revitalizing agriculture in Namibia. Its primary objectives include promoting sustainable farming practices, enhancing water management, controlling bush encroachment, improving market access, and developing essential infrastructure. By focusing on these areas, STAS seeks to address the root causes of agricultural underperformance and unlock the sector's potential.
      <br />
      A pivotal component of STAS is the integration of smart farming technologies to modernize agricultural practices. Precision agriculture, which utilizes data-driven approaches to optimize farming operations, has emerged as a promising solution. This has led to the emergence of companies that offer satellite-based farm management solutions that provide real-time insights into crop health, soil conditions, and weather patterns. These technologies enable farmers to make informed decisions, optimize resource use, and increase productivity.
      <br /><br />

      <strong>The Need for Data-Driven Agriculture</strong>
      <br />
      Recognizing the importance of accurate and timely data in agricultural planning, the Food and Agriculture Organization (FAO) and the Namibia Statistics Agency (NSA) have collaborated to develop the Strategic Plan for Agricultural and Rural Statistics (SPARS). This initiative aims to enhance the collection, analysis, and dissemination of agricultural data, providing a solid foundation for policy formulation and decision-making. By improving data quality and accessibility, SPARS supports the effective implementation of agricultural strategies and interventions.
      <br />
      In addressing challenges such as drought and limited grazing lands, innovative solutions like hydroponic fodder production have been introduced. This method involves growing fodder in a controlled, soil-less environment, significantly reducing water usage and ensuring a consistent feed supply for livestock. The FAO, in collaboration with local experts, has trained Namibian farmers in hydroponic techniques, enhancing resilience against climate-induced feed shortages and supporting livestock productivity.
      <br /><br />

      <strong>Trade and Market Access Opportunities Provided by Farmnet</strong>
      <br />
      Namibia's agricultural products have access to international markets through agreements like the African Growth and Opportunities Act (AGOA), which allows duty-free exports to the United States for over 6,400 products. In 2016, Namibia became eligible to export meat and meat products to the U.S., opening new avenues for the livestock sector. These trade opportunities incentivize the adoption of quality standards and sustainable practices, aligning with global market requirements.
      <br />
      Despite these opportunities, Namibia imposes certain trade restrictions, particularly on agricultural products like white maize, wheat, and mahangu (pearl millet). Import and export of these controlled grains require permits issued by the Agronomic Board and the Ministry of Agriculture, Water and Land Reform. While these measures aim to protect local producers, they can also pose challenges for market expansion and trade efficiency.
      <br />
      New platforms such as Farmnet Africa have risen to address market access concerns by providing smallholder farmers with comprehensive digital solutions that streamline various aspects of agricultural production and sales. Farmnet Africa offers a suite of services, including better planning and management tools, access to providers, disease management, farming guides, funding opportunities, and food tracking from farm to table. These features empower farmers with actionable insights and visibility into their operations, enabling them to thrive as entrepreneurs. By leveraging such platforms, farmers can overcome traditional barriers, access broader markets, and enhance their productivity and profitability.
      <br /><br />

      <strong>Conclusion</strong>
      <br />
      Namibia's agricultural sector is at a pivotal juncture, with the potential to transform into a more productive and sustainable industry. By implementing strategic plans like STAS, embracing smart farming technologies, enhancing data-driven decision-making, and leveraging trade opportunities, Namibia can overcome existing challenges and secure a prosperous future for its agricultural community. Continued collaboration among government agencies, international organizations, technology providers, and local farmers, as well as continued adoption and use of platforms such as Farmnet Africa will be essential in driving this transformation forward.
    </p>

    <div className="md:h-5 h-2"></div>
  </div>
</div>

    </div>
   </div>
  );
};

export default Argitech3;
